<template>
	<div class="app-combobox">
		<div :class="comboboxClass">
			<v-combobox v-bind="$attrs" v-on="$listeners" multiple outlined :attach="`.${comboboxClass}`">
				<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
				<template v-slot:no-data>
					<slot name="no-data" />
				</template>
				<!-- These two slots are a must, to allow no-data. don't delete these -->
				<template v-slot:prepend>
					<slot name="prepend" />
				</template>
			</v-combobox>
		</div>
	</div>
</template>

<script>
import { v4 as uuid } from 'uuid';
const COMBOXBOX_CLASS = 'app-combobox-content';
export default {
	name: 'AppCombobox',
	props: {},
	computed: {
		comboboxClass() {
			return `${COMBOXBOX_CLASS}-${this.id}`;
		},
	},
	data() {
		return {
			id: uuid(),
		};
	},
};
</script>

<style scoped lang="scss">
.app-combobox {
	position: relative; // so that menu is attached in relation to this selector

	::v-deep {
		.v-text-field--outlined fieldset {
			background-color: var(--input-bg-color);
			border: var(--primary-border) !important;
			border-radius: var(--input-border-radius);
		}

		.v-input__slot[role='combobox'] {
			padding: 0 !important;
		}

		.v-autocomplete__content.v-menu__content {
			box-shadow: var(--box-shadow-dark);
			border-radius: 6px;

			.v-list {
				.v-subheader {
					height: 30px;
					margin: 2px 0;
					padding: 0 10px;
					color: #292829;
				}
				.v-list-item {
					padding: 0 8px;
					border-bottom: var(--primary-border);
				}
				.v-list-item:last-child {
					border: none;
				}
			}
		}
		input {
			padding-left: 8px;
		}
		.v-input__icon--append {
			margin-right: 10px;
		}

		.v-select__selections {
			position: absolute;
			top: 0;
			height: 100%;
			width: 100%;
			overflow-y: auto;
			padding-right: 80px !important;
		}
	}
}
</style>
